import { ConfigElement } from "../../components-fabric";
import { authSection } from "./auth";
import { errorsSection } from "./errors";
import { homeSection } from "./home";
import { supportSection } from "./support/support";

/**
 * Configuration Array: publicAreaScreens
 *
 * This array holds the configuration elements for the public area of the application, defining the different sections 
 * and screens accessible to all users, regardless of authentication status.
 *
 * Properties:
 * 
 * @property {ConfigSection} homeSection - Represents the home section, which includes the main landing or home screen of the application.
 * @property {ConfigSection} errorsSection - Contains the various error screens such as 404 Not Found, 403 Forbidden, and 500 Internal Server Error.
 * @property {ConfigSection} authSection - Includes the authentication screens like login and logout, accessible to users for managing access.
 * @property {ConfigSection} supportSection - Includes support-related screens for user assistance and help.
 */
export const publicAreaScreens: ConfigElement[] = [
  homeSection,
  errorsSection,
  authSection,
  supportSection
]
